import { DialogDraggableHeaderModule } from 'src/app/shared/dialog-draggable-header/dialog-draggable-header.module';
import { DropdownModule } from 'primeng/dropdown';
import { SearchableAutocompleteModule } from './../searchable-autocomplete/searchable-autocomplete.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './data-table.component';
import { TableModule as PrimengTableModule } from 'primeng/table';
import { MultiSelectModule as PrimengMultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FormsModule } from '@angular/forms';
import { ActionStartDirective } from './directives/action-start.directive';
import { ActionEndDirective } from './directives/action-end.directive';
import { TitleDirective } from './directives/title.directive';
import { PlatformModule } from '@angular/cdk/platform';

@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      MatInputModule,
      MatCheckboxModule,
      MatButtonModule,
      MatDatepickerModule,
      MatSelectModule,
      PrimengTableModule,
      MatIconModule,
      PrimengMultiSelectModule,
      MatTooltipModule,
      MatDividerModule,
      OverlayPanelModule,
      SearchableAutocompleteModule,
      PlatformModule,
      DropdownModule,
      DialogDraggableHeaderModule
   ],
   declarations: [
      DataTableComponent,
      ActionStartDirective,
      ActionEndDirective,
      TitleDirective
   ],
   exports: [
      DataTableComponent
   ]
})
export class DataTableModule { }
